import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AUTH_LOGOUT } from 'actions/auth';
import { INITIAL_SYNC_PRODUCTS } from 'actions/sync-products';
import GeneralInfoForm from 'pages/account-settings/GeneralInfoForm';
import PasswordForm from 'pages/account-settings/PasswordForm';
import Cards from 'pages/account-settings/Cards';
import {
  updateUserInformation,
  deactivateUser,
  updatePassword,
} from 'actions/user';

const AccountSettings = ({ user, setUser }) => {
  const dispatch = useDispatch();
  const countries = useSelector((state) => state?.countries?.data);

  return (
    <div>
      {user && countries && (
        <GeneralInfoForm
          user={user}
          countries={countries}
          update={async (data) => {
            const request = await dispatch(updateUserInformation(data));

            if (request?.error) {
              return;
            }
            setUser(undefined);
          }}
        />
      )}
      <PasswordForm
        user={user}
        updatePassword={async (payload) => {
          const request = await dispatch(updatePassword(payload));

          if (request?.error) {
            return;
          }
          setUser(undefined);
        }}
        deactivate={async () => {
          const data = {
            userId: user?.User?.Email,
            password: user?.User?.PasswordHash,
          };

          const request = await dispatch(deactivateUser(data));

          if (request?.error) {
            return;
          }
          dispatch({ type: AUTH_LOGOUT });
          dispatch({ type: INITIAL_SYNC_PRODUCTS });
        }}
      />
      <Cards />
    </div>
  );
};

export default AccountSettings;
